import React from 'react';

import './asterisk.scss';

export const Asterisk = () => <span className="asterisk">*</span>;
